import { Injectable } from "@angular/core";
import { Actions, Store } from "@ngxs/store";
import * as FlatModels from '@medsurf/flat-models';
import * as FlatActions from '@medsurf/flat-actions';
import * as FlatStates from '@medsurf/flat-states';

@Injectable()
export class TextExportAuthorFacade {
  constructor(protected store: Store,
              protected actions$: Actions) {
  }

  //<editor-fold desc="Selectors">

  currentIsLoading$ = this.store.select(FlatStates.TextExportAuthorState.currentIsLoading$);
  currentHasLoaded$ = this.store.select(FlatStates.TextExportAuthorState.currentHasLoaded$);
  currentTextExportObjects$ = this.store.select(FlatStates.TextExportAuthorState.currentTextExportObjects$)

  //</editor-fold>


  //<editor-fold desc="Requests">

  requestGetTextExports(node: FlatModels.NodeEntityModels.NodeEntityType) {
    return this.store.dispatch(new FlatActions.TextExportAuthorActions.GetTextExports(node.id));
  }

  //</editor-fold>
}